const choices = {
    loan: 'Crédit',
    LOA: 'Location avec option d\'achat',
    LLD: 'Location longue durée',
};

export default choices;
